import _ from 'lodash';

export const getTermFromState = (state, term) => {
  const i18n = _.get(state, 'i18n');
  return _.get(i18n, term);
}



/** WEBPACK FOOTER **
 ** ./src/redux/selectors/i18n.js
 **/